import { AxiosResponse } from 'axios';

import { QueryObserverOptions, useQueryClient } from '@tanstack/react-query';

import type { TypeCodeState } from '../../types';
import { API_VERSION_V2 } from '~/constants';
import { axiosInstance } from '~/services/fetchServiceV2';
import { type TypeErrorFormat, requestHelper } from '~/utils/fetchHelper';

export type TypeCheckContractStatusResponse = {
  code: string;
  message: string;
  data: {
    name: string;
    juminNo: string;
    phoneNo: string;
    postCode: string;
    address: string;
    detailAddress: string;
    financialInstitution: TypeCodeState;
    accountNo: string;
    certificationStatus: TypeCodeState;
    fullAddress: string;
  };
};

/**
 * @description 근로계약 체결을 위한 사전 정보가 있는지 확인
 */
export const useCheckContractStatus = () => {
  const queryClient = useQueryClient();

  const requestCheckContractStatus = async ({
    onSuccess,
    onError,
    queryConfig,
  }: {
    onSuccess?: (res: TypeCheckContractStatusResponse) => void;
    onError?: (err: TypeErrorFormat) => void;
    queryConfig?: Omit<QueryObserverOptions<AxiosResponse<TypeCheckContractStatusResponse>>, 'queryKey' | 'queryFn'>;
  }) => {
    const endpoint = '/labor/contracts/check';
    const query = queryClient.ensureQueryData<AxiosResponse<TypeCheckContractStatusResponse>>({
      queryKey: ['labor', 'contracts', 'check'],
      queryFn: () =>
        axiosInstance.get(endpoint, {
          headers: {
            version: API_VERSION_V2,
          },
        }),
      ...queryConfig,
    });

    return requestHelper(() => query, onSuccess, onError);
  };

  return requestCheckContractStatus;
};
